var _excluded = ["isOpen", "onClose", "title", "transitionDuration", "showHeader", "insetContent", "renderHeader", "children", "className"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { Card, Button } from "@blueprintjs/core";
import hyper from "@macrostrat/hyper";
import classNames from "classnames";
import styles from "./card.module.styl";
var h = hyper.styled(styles);

var CloseableCardHeader = function CloseableCardHeader(props) {
  return h("div.card-header-left", props);
};

var CloseableCard = function CloseableCard(props) {
  var _props$isOpen = props.isOpen,
      isOpen = _props$isOpen === void 0 ? true : _props$isOpen,
      onClose = props.onClose,
      title = props.title,
      transitionDuration = props.transitionDuration,
      _props$showHeader = props.showHeader,
      showHeader = _props$showHeader === void 0 ? true : _props$showHeader,
      _props$insetContent = props.insetContent,
      insetContent = _props$insetContent === void 0 ? true : _props$insetContent,
      renderHeader = props.renderHeader,
      children = props.children,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded);

  if (!isOpen) {
    return null;
  }

  rest.className = classNames("closeable-card", className); // Set header from "CloseableCardHeader" unless  not set,
  // otherwise use "title"

  var header = null;

  if (renderHeader != null) {
    header = renderHeader();
  }

  if (header == null && title != null) {
    if (title != null) {
      title = h("h4", title);
    }

    header = h([title]);
  }

  return h(Card, rest, [h["if"](showHeader)("div.card-header", [header, //h("div.spacer"),
  h(Button, {
    icon: "small-cross",
    className: "card-close-button",
    minimal: true,
    "aria-label": "Close",
    onClick: onClose
  })]), h("div.card-content", {
    className: classNames({
      inset: insetContent
    })
  }, children)]);
};

CloseableCard.Header = CloseableCardHeader;
export { CloseableCard };